<script>
    export let tasks;
    import Plus from "svelte-bootstrap-icons/lib/Plus";
    import Dash from "svelte-bootstrap-icons/lib/Dash";
    import DelegateButton from "./DelegateButton.svelte";
    import DeferButton from "./DeferButton.svelte";
    import DoButton from "./DoButton.svelte";
    import DoneButton from "./DoneButton.svelte";
    import EnumStatus from "../services/taskstatus";
  
 </script>

<table class="table table-striped">
    <thead>
      <tr>
        <th scope="col">Scheduled</th>        
        <th scope="col">Name</th>
        <th scope="col">Priority</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
        {#each tasks.slice(0, 500) as task}
    <tr>
        <th scope="row">{(task.nextaction).toLocaleDateString()}</th> 
        <th>{task.name}</th>
        <td>
            <Plus/>
            {task.priority}
            <Dash/>
        </td>
        <td>
            <DoButton bind:data={task}/>
            <DeferButton bind:data={task}/>  
            <DelegateButton bind:data={task}/>                
            <DoneButton bind:data={task}/>  
        </td>
      </tr>
        {/each}
    </tbody>
</table>

